/**
 * API do checklist. Admin only.
 * Persistência no backend em vez de localStorage.
 */

import { api } from '@/lib/api/client'
import type { ChecklistState } from '@/types/checklist'

interface ChecklistResponse {
  topics: ChecklistState['topics']
}

export async function fetchChecklist(): Promise<ChecklistState> {
  const data = await api.get<ChecklistResponse>('/api/admin/checklist', {
    requireAuth: true,
  })
  return { topics: data.topics ?? [] }
}

export async function saveChecklist(state: ChecklistState): Promise<ChecklistState> {
  const data = await api.put<ChecklistResponse>('/api/admin/checklist', state, {
    requireAuth: true,
  })
  return { topics: data.topics ?? [] }
}
